import { type ConflictType } from '@consigli/types';

import { conflictTypeContextKind } from './add-context/finding-context-kind';
import { type AddContextMenuKind } from './types';

/** The kinds a cited source is shown under, in the order the sources modal lists them. */
export const SOURCE_KINDS: AddContextMenuKind[] = [
  'document',
  'finding',
  'milestone',
  'response-requirement',
];

/** "View Documents (4)" and its kin, for a row or a title that names one kind. */
export const VIEW_KEYS: Record<AddContextMenuKind, string> = {
  document: 'prop-chat.view-documents',
  finding: 'prop-chat.view-findings',
  milestone: 'prop-chat.view-milestones',
  'response-requirement': 'prop-chat.view-response-requirements',
};

export type SourceCounts = Record<AddContextMenuKind, number>;

/** A finding as the answer cited it, before the finding itself is fetched. */
export interface CitedFinding {
  findingId: number;
  /** Absent when the stream sent a bare id. */
  conflictType?: ConflictType;
}

/**
 * How many sources of each kind an answer cites, without fetching a finding.
 *
 * A finding the stream sent without its conflict type counts as a finding,
 * which a milestone or a response requirement also is.
 */
export const countSources = (documentCount: number, findings: CitedFinding[]): SourceCounts => {
  const counts: SourceCounts = {
    document: documentCount,
    finding: 0,
    milestone: 0,
    'response-requirement': 0,
  };
  for (const { conflictType } of findings) {
    counts[conflictType ? conflictTypeContextKind(conflictType) : 'finding'] += 1;
  }
  return counts;
};

export const presentSourceKinds = (counts: SourceCounts): AddContextMenuKind[] =>
  SOURCE_KINDS.filter((kind) => counts[kind] > 0);
